export default __webpack_public_path__ + "3e9c9669de73845a8469167b7be8e9cc.png";